export interface FundsUnderManagement {
  currency: string;
  value: {
    _val: number;
    _type: string;
  };
}
